import { render, staticRenderFns } from "./wxAppIdDialog.vue?vue&type=template&id=6be6e4f3&scoped=true&"
import script from "./wxAppIdDialog.vue?vue&type=script&lang=js&"
export * from "./wxAppIdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be6e4f3",
  null
  
)

export default component.exports